import { render } from "./Composites.vue?vue&type=template&id=77680834&scoped=true"
import script from "./Composites.vue?vue&type=script&lang=js"
export * from "./Composites.vue?vue&type=script&lang=js"

import "./Composites.vue?vue&type=style&index=0&id=77680834&scoped=true&lang=css"

import exportComponent from "/Users/pmerkuloff/Web/hlv/FRONT/hpanel/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77680834"]])

export default __exports__